import Model from '../Model';
import { DISTRIBUTION_CONSTANTS, STATUS_LABELS } from '../../../constants/distribution.constants';
import ViewHelpers from '../../utils/view.helpers';

export default class DistributionModel extends Model {
    constructor(data) {
        super(data);
        this.id = data.id;
        this.type = DISTRIBUTION_CONSTANTS.DISTRIBUTION_TYPE[data.type && data.type.toUpperCase()];
        this.friendlyId = data.friendly_id;
        this.coverage = data.coverage;
        this.viewCoverage = '';
        this.numericViewCoverage = 0;
        if (this.coverage) {
            const { progressInPercents, viewCoverage } = ViewHelpers.getProgress(this.coverage, 1);
            this.viewCoverage = viewCoverage;
            this.numericViewCoverage = progressInPercents;
        }
        this.status = data.status;

        if (this.status) {
            if (this.status === STATUS_LABELS.NOT_DISTRIBUTED) {
                this.viewStatus = _.find(DISTRIBUTION_CONSTANTS.DISTRIBUTION_STATUS, status => status.label === STATUS_LABELS.PENDING_DISTRIBUTION);
                this.details = _.find(DISTRIBUTION_CONSTANTS.DISTRIBUTION_STATUS, status => status.label === this.status).details;
            } else {
                this.viewStatus = _.find(DISTRIBUTION_CONSTANTS.DISTRIBUTION_STATUS, status => status.label === this.status);
            }
        }
        this.description = data.description || '';
        this.date = data.date;
        this.formattedDate = ViewHelpers.formatDate(data.date);
        this.site = data.edge_node_name;
        this.siteUrl = data.edge_node_url;
        this.nodeErrors = data.node_error || {};
        this.fileErrors = data.file_errors ? data.file_errors.sort() : [];

        if (this.viewStatus && this.viewStatus.details) {
            this.details = this.viewStatus.details;
        } else if (this.coverage && this.coverage.distributed_count === this.coverage.total_count) {
            this.details = 'Closing distribution';
        } else if (data.filesInProgress && data.filesInProgress.length) {
            this.details = `Files in progress: ${data.filesInProgress.join(', ')}`;
        }


        this.hasDistributionPermissoinToSite = data.hasDistributionPermissoinToSite;
        this.hasDeletionPermissoinToSite = data.hasDeletionPermissoinToSite;
    }
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/DistributionModel.js